import { Star } from "lucide-react";
import { useLanguage } from "@/contexts/LanguageContext";

const reviews = [
  {
    name: "Jenny Diaz",
    badge: "Local Guide",
    rating: 5,
    text: "Most honest Plumber I have worked with in a long time, doesn't overcharge, is punctual and communicates well about everything, very professional and I highly recommend him. Thank you 🙏"
  },
  {
    name: "Bryan Brough",
    badge: "Local Guide",
    rating: 5,
    text: "Professional, punctual, and highly skilled. Francisco provided top-tier service and made a stressful situation easy."
  },
  {
    name: "Jill McFee",
    badge: null,
    rating: 5,
    text: "Great communication! Responded and repaired quickly. Highly recommend."
  }
];

const GoogleIcon = () => (
  <svg className="w-4 h-4" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    <path d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z" fill="#4285F4"/>
    <path d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z" fill="#34A853"/>
    <path d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z" fill="#FBBC05"/>
    <path d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z" fill="#EA4335"/>
  </svg>
);

const ReviewsSection = () => {
  const { language } = useLanguage();

  return (
    <section id="reviews" className="py-10 md:py-14 bg-gradient-to-b from-slate-50 to-white" data-testid="reviews-section">
      <div className="max-w-7xl mx-auto px-4 md:px-8 lg:px-16">
        {/* Section Header */}
        <div className="text-center mb-8 md:mb-10">
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-[#0F172A] mb-3" style={{ fontFamily: "'Playfair Display', serif" }}>
            {language === 'en' ? 'Customer Reviews' : 'Opiniones de Clientes'}
          </h2>
          <div className="w-20 h-1 bg-[#D4AF37] mx-auto"></div>
        </div>

        {/* Reviews Grid */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-6">
          {reviews.map((review, index) => (
            <div 
              key={index}
              className="bg-white p-5 md:p-6 rounded-xl shadow-md hover:shadow-lg transition-shadow duration-300 border border-slate-100"
              data-testid={`review-card-${index}`}
            >
              {/* Google Verified Badge */}
              <div className="flex items-center gap-1.5 mb-3 text-xs text-slate-500">
                <GoogleIcon />
                <span>Verified Google Review</span>
              </div>

              {/* Stars */}
              <div className="flex gap-0.5 mb-3">
                {[...Array(review.rating)].map((_, i) => (
                  <Star key={i} className="w-4 h-4 fill-[#FBBC05] text-[#FBBC05]" />
                ))}
              </div>

              {/* Review Text */}
              <p className="text-slate-700 text-sm leading-relaxed mb-4">
                "{review.text}"
              </p>

              {/* Reviewer Info */}
              <div className="flex items-center gap-2 pt-3 border-t border-slate-100">
                <div className="w-8 h-8 bg-[#0F172A] rounded-full flex items-center justify-center">
                  <span className="text-white font-bold text-xs">
                    {review.name.charAt(0)}
                  </span>
                </div>
                <div>
                  <p className="font-semibold text-[#0F172A] text-sm">{review.name}</p>
                  {review.badge && (
                    <p className="text-xs text-[#4285F4] font-medium">{review.badge}</p>
                  )}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
      
      {/* Gold Divider Line */}
      <div className="max-w-4xl mx-auto mt-10 md:mt-14 px-4">
        <div className="h-[2px] bg-gradient-to-r from-transparent via-[#D4AF37] to-transparent"></div>
      </div>
    </section>
  );
};

export default ReviewsSection;
